import { render, staticRenderFns } from "./SalaMunicipioPrincipal.vue?vue&type=template&id=8613681e&"
import script from "./SalaMunicipioPrincipal.vue?vue&type=script&lang=js&"
export * from "./SalaMunicipioPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./SalaMunicipioPrincipal.vue?vue&type=style&index=0&id=8613681e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports